export const abbreviateText = (
  text: string,
  maxLength: number,
  fallback = "~~",
): string => {
  if (!text) return fallback;
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};

export const formatJsonText = (value: unknown, fallback = "~~"): string => {
  if (value === undefined || value === null || value === "") return fallback;

  if (typeof value === "string") {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch (error) {
      return value;
    }
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return fallback;
  }
};
